import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

// Import themes modules
import COLORS from '../../themes/Colors'
import { px2Rem } from '../../themes/Mixins'

// Import common components
import { FlexBox } from './Box'

const Wrapper = FlexBox.extend`
  background-color: transparent;
  height: ${props => props.height};
  width: ${props => props.width};
`

const BodyArrow = styled.div`
  background-color: ${props => props.bgColor};
  width: 50%;
  flex: 1;
`

const TopArrow = styled.div`
  background-color: transparent;
  border: 0 solid transparent;
`

// Defined component Icon
export default class Arrow extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.setBorderWidthTopArrow();
  }

  getWidthArrow = (width) => {
    if (width.indexOf('%') > 0) {
      return px2Rem(this.arrowWrapper.getBoundingClientRect().width)
    }

    return width
  }

  setBorderWidthTopArrow = () => {
    const { width, bgColor } = this.props;

    this.arrowTop.style['border-left-width'] = `calc(${this.getWidthArrow(width)}/2)`;
    this.arrowTop.style['border-right-width'] = `calc(${this.getWidthArrow(width)}/2)`;
    this.arrowTop.style['border-top'] = `calc(${this.getWidthArrow(width)}*1.625) solid ${bgColor}`;
  }

  render() {
    const { width, height, bgColor, customStyle, className } = this.props;
    return (
      <Wrapper
        innerRef={el => this.arrowWrapper = el}
        width={width}
        height={height}
        alignItems='center'
        flexDirection='column'
        customStyle={customStyle}
        className={className}
      >
        <BodyArrow
          width={width}
          bgColor={bgColor}
        />
        <TopArrow
          innerRef={el => this.arrowTop = el}
          width={width}
          bgColor={bgColor}
        />
      </Wrapper>
    )
  }
}

Arrow.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
}

// Defined default Props
Arrow.defaultProps = {
  width: px2Rem(8),
  height: '100%',
  bgColor: COLORS.bgArrow
}



// WEBPACK FOOTER //
// ./src/components/common/Arrow.js